export const TransferredTemplate = {
    name: 'transferred',
    label: 'Done',
    subject: "REBIT ${reference}: Completed!",
    category: 'compulsory',
    body: "<p>Hi ${payer_name},</p>"
        + "<p>✅ <b>We have transferred your ${received_amount} ${dest_currency}.</b></p>"
        + "<p>📤 You paid ${paid_amount} ${origin_currency}.</p>"
        + "<p>🏦 Depending on networks, <b>${recipient_name}</b> should receive it shortly. Please note, local bank networks do not operate during weekends or public holidays, in some countries.</p>"
        + "<p>➕ To view transactions breakdown and totals, please check <b>WE PAID</b> | <b>YOU PAID</b> tabs under <b>Tracking</b>. Below is the breakdown of our payments:</p>"
        + "<table class='table' style='width: 100%; text-align: left; padding:10px 0'>"
        + "<tr><th>Date (UTC)</th><th>Amount</th><th>Status</th></tr>"
        + "<tr>"
        + "<td>00:00 - 01 Jan 0000</td><td>0 ${dest_currency}</td><td style='color: green'>Accepted</td>"
        + "</tr>"
        + "</table>"
        + "<p>✉️ Read more about Transfer Time or Contact us via <a href='https://my.rebitmoney.com/help-and-support/tracking'>Help & Support</a></p>"
        + "<h6 style='font-size:16px; text-align: center; margin: 0; padding: 10px'>Share Rebit, receive cash Rewards!<sup>*</sup></h6>"
        + "<p style='padding:20px; text-align: center'>"
        + "<a href='https://my.rebitmoney.com/transfers/history' style='padding:10px;background-color: #4e54c8;color: white;border-radius: 4px;text-decoration: none'>Start Earning</a>"
        + "</p>"
        + "<small>* <a href='https://rebitmoney.com/blog/share-rebit-get-rewards'>Rewards terms and conditions apply</a></small>"
}

